interface UserPointsBadgeProps {
  points: number;
}

const UserPointsBadge = ({ points }: UserPointsBadgeProps) => {
  return (
    <div className="flex items-center gap-1.5 bg-gradient-to-r from-yellow-100 to-yellow-50 border border-yellow-300 rounded-full px-3 py-1.5">
      <span className="text-base">⭐</span>
      <span className="text-sm font-semibold text-yellow-800">{points.toLocaleString()}</span>
      <span className="text-xs text-yellow-600 font-medium">pts</span>
    </div>
  );
};

export default UserPointsBadge;
